import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class IdDto {
  @Field(type => Int)
  id!: number
}
